/**
 * Describes system settings
 */
export class Settings {
    tenantName: string = '';
    tenantAdminFunctionsExcluded: Array<string>;
}

/**
 * Describes the Admin Functionality available
 */
export class AdminFunctionality {
  isDashboardVisible: boolean = false;
  isSuppliersVisible: boolean = false;
  isDatasetsVisible: boolean = false;
  isDataloadsVisible: boolean = false;
  isMapservicesVisible: boolean = false;
  isDataservicesVisible: boolean = false;
  isCustomersVisible: boolean = false;
  isReportsVisible: boolean = false;
  isSystemconfigVisible: boolean = false;
  isMapproxyconfigVisible: boolean = false;

  /**
   * Sets the visibility of the Admin Functionality based on settings
   * @param settings
   */
  setVisible(settings: Settings) {
    if (!settings.tenantAdminFunctionsExcluded.includes('dashboard')) {
      this.isDashboardVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('suppliers')) {
      this.isSuppliersVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('datasets')) {
      this.isDatasetsVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('dataloads')) {
      this.isDataloadsVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('mapservices')) {
      this.isMapservicesVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('dataservices')) {
      this.isDataservicesVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('customers')) {
      this.isCustomersVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('reports')) {
      this.isReportsVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('systemconfig')) {
      this.isSystemconfigVisible = true;
    }
    if (!settings.tenantAdminFunctionsExcluded.includes('mapproxyconfig')) {
      this.isMapproxyconfigVisible = true;
    }
  }
}
